export const ArchShape = ({ className = "", strokeWidth = 10 }) => (
  <svg viewBox="0 0 200 240" className={className} fill="none" stroke="currentColor" strokeWidth={strokeWidth} aria-hidden="true">
    <path d="M10 240V100a90 90 0 0 1 180 0V240" />
    <path d="M55 240V105a45 45 0 0 1 90 0V240" />
  </svg>
);

export const HalfCircle = ({ className = "" }) => (
  <svg viewBox="0 0 200 200" className={className} fill="currentColor" aria-hidden="true">
    <path d="M100 0a100 100 0 0 0 0 200V160a60 60 0 0 1 0-120Z" />
  </svg>
);

export const Sprout = ({ className = "", strokeWidth = 10 }) => (
  <svg viewBox="0 0 120 140" className={className} fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinejoin="round" strokeLinecap="round" aria-hidden="true">
    <path d="M60 135V35" />
    <path d="M60 38Q64 8 110 6Q106 36 60 38Z" />
    <path d="M60 82Q64 54 110 52Q106 80 60 82Z" />
    <path d="M56 62Q52 34 10 32Q14 60 56 62Z" />
  </svg>
);

export const Comb = ({ className = "" }) => (
  <svg viewBox="0 0 200 60" className={className} fill="currentColor" aria-hidden="true">
    {[10, 60, 110, 160].map((x) => (
      <rect key={x} x={x} y="0" width="22" height="60" rx="11" />
    ))}
  </svg>
);
